import React, { useState, useEffect, useRef, useCallback } from "react";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";
import UserSidebar from "../../components/UserSidebar";
import achalLogo from "../../assets/images/achal_logo.png";

// ─── FORMAT BYTES ───
const formatBytes = (b) => {
  if (!b) return "";
  if (b < 1024) return `${b} B`;
  if (b < 1048576) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1048576).toFixed(2)} MB`;
};

// ─── SVG ICONS (no lucide) ───
const Icons = {
  logout: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  map: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  back: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>,
  check: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  chevron: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>,
  send: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  search: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  xmark: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  sortAZ: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="9" y2="18"/></svg>,
  grid: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  list: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  camera: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  video: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>,
  mic: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>,
  upload: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>,
  stop: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="6" width="12" height="12" rx="2"/></svg>,
  recDot: <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="12"/></svg>,
  music: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>,
  trash: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
  alertCircle: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  checkCircle: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
  fileText: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  layers: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>,
  clipboard: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>,
};

// ─── DROP ZONE ───
const DropZone = ({ type, accept, icon, label, file, preview, onFile, onRemove }) => {
  const [dragging, setDragging] = useState(false);
  const [prog, setProg] = useState(0);
  const [uploading, setUploading] = useState(false);
  const ref = useRef();

  const simulate = (f) => {
    if (f.size > 10485760) { alert("Max 10MB allowed"); return; }
    setUploading(true); setProg(0);
    let p = 0;
    const iv = setInterval(() => {
      p += Math.random() * 22 + 12;
      if (p >= 100) { clearInterval(iv); setUploading(false); onFile(f); p = 100; }
      setProg(Math.min(p, 100));
    }, 80);
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        onClick={() => !file && !uploading && ref.current.click()}
        onDragOver={e => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={e => { e.preventDefault(); setDragging(false); const f = e.dataTransfer.files[0]; if (f) simulate(f); }}
        style={{
          border: `1.5px dashed ${dragging ? "var(--gold)" : file ? "var(--success)" : "var(--border)"}`,
          borderRadius: 14, background: dragging ? "rgba(212,175,55,0.06)" : file ? "rgba(34,197,94,0.04)" : "var(--surface2)",
          padding: "18px 14px", cursor: file ? "default" : "pointer",
          display: "flex", flexDirection: "column", alignItems: "center", gap: 8,
          transition: "all 0.2s", minHeight: 110, overflow: "hidden",
        }}
      >
        {uploading ? (
          <>
            <div style={{ width: "100%", height: 3, background: "var(--border)", borderRadius: 99 }}>
              <div style={{ height: "100%", width: `${prog}%`, background: "var(--gold)", borderRadius: 99, transition: "width 0.08s" }} />
            </div>
            <span style={{ fontSize: 12, color: "var(--textMuted)", fontWeight: 600 }}>Uploading {Math.round(prog)}%</span>
          </>
        ) : file ? (
          <>
            {preview && type === "image"
              ? <img src={preview} alt="prev" style={{ width: "100%", height: 60, objectFit: "cover", borderRadius: 10 }} />
              : <div style={{ color: "var(--success)" }}>{Icons.checkCircle}</div>
            }
            <span style={{ fontSize: 11, color: "var(--textMuted)", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
            <span style={{ fontSize: 11, fontWeight: 700, color: "var(--gold)" }}>{formatBytes(file.size)}</span>
          </>
        ) : (
          <>
            <div style={{ color: dragging ? "var(--gold)" : "var(--textMuted)" }}>{icon}</div>
            <span style={{ fontSize: 12, fontWeight: 600, color: "var(--text2)" }}>{label}</span>
            <span style={{ fontSize: 11, color: "var(--textMuted)" }}>Drop or click to upload</span>
          </>
        )}
        <input ref={ref} type="file" accept={accept} hidden onChange={e => { const f = e.target.files[0]; if (f) simulate(f); }} />
      </div>
      {file && !uploading && (
        <button type="button" onClick={onRemove} style={{
          position: "absolute", top: 7, right: 7, width: 22, height: 22, borderRadius: "50%",
          background: "#EF4444", border: "none", color: "#fff", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>{Icons.xmark}</button>
      )}
    </div>
  );
};

// ─── AUDIO RECORDER ───
const AudioRecorder = ({ audioFile, onAudio, onRemove }) => {
  const [mode, setMode] = useState("idle");
  const [secs, setSecs] = useState(0);
  const [prog, setProg] = useState(0);
  const [wave, setWave] = useState(0);
  const mrRef = useRef(); const chunksRef = useRef([]);
  const timerRef = useRef(); const waveRef = useRef();
  const uploadRef = useRef();
  const bars = [5, 14, 20, 11, 22, 9, 17, 7, 19, 13, 21, 10, 16, 8, 6];

  useEffect(() => {
    if (mode === "recording") { waveRef.current = setInterval(() => setWave(v => v + 1), 120); }
    else clearInterval(waveRef.current);
    return () => clearInterval(waveRef.current);
  }, [mode]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      mrRef.current = mr; chunksRef.current = [];
      mr.ondataavailable = e => chunksRef.current.push(e.data);
      mr.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        const f = new File([blob], `voice_${Date.now()}.webm`, { type: "audio/webm" });
        stream.getTracks().forEach(t => t.stop());
        onAudio(f); setMode("done"); clearInterval(timerRef.current);
      };
      mr.start(); setMode("recording"); setSecs(0);
      timerRef.current = setInterval(() => setSecs(s => s + 1), 1000);
    } catch { alert("Microphone access denied"); }
  };

  const stop = () => { mrRef.current?.stop(); clearInterval(timerRef.current); };

  const uploadFile = (f) => {
    if (!f || f.size > 10485760) { alert("Max 10MB"); return; }
    setMode("uploading"); setProg(0);
    let p = 0;
    const iv = setInterval(() => {
      p += Math.random() * 22 + 14;
      if (p >= 100) { clearInterval(iv); setMode("done"); onAudio(f); p = 100; }
      setProg(Math.min(p, 100));
    }, 80);
  };

  const fmt = s => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

  if (mode === "done" && audioFile) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", border: "1.5px solid var(--success)", borderRadius: 14, padding: "14px 18px", background: "rgba(34,197,94,0.04)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 38, height: 38, borderRadius: "50%", background: "rgba(34,197,94,0.1)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--success)" }}>{Icons.music}</div>
        <div>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "var(--text1)" }}>{audioFile.name}</p>
          <p style={{ margin: 0, fontSize: 11, color: "var(--textMuted)" }}>{formatBytes(audioFile.size)}</p>
        </div>
      </div>
      <button type="button" onClick={() => { onRemove(); setMode("idle"); setSecs(0); }} style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(239,68,68,0.1)", border: "none", color: "#EF4444", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>{Icons.trash}</button>
    </div>
  );

  if (mode === "recording") return (
    <div style={{ border: "1.5px solid #EF4444", borderRadius: 14, background: "rgba(239,68,68,0.03)", padding: "22px 20px", display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 34 }}>
        {bars.map((h, i) => (
          <div key={i} style={{ width: 4, borderRadius: 2, background: "#EF4444", height: `${Math.max(4, h * Math.abs(Math.sin((wave + i) * 0.45)) + 4)}px`, transition: "height 0.1s" }} />
        ))}
      </div>
      <p style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "#EF4444", fontVariantNumeric: "tabular-nums", fontFamily: "'DM Mono', monospace, 'JetBrains Mono', monospace" }}>{fmt(secs)}</p>
      <button type="button" onClick={stop} style={{
        width: 50, height: 50, borderRadius: "50%", background: "#EF4444", border: "none",
        color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
        animation: "recPulse 1.5s infinite"
      }}>{Icons.stop}</button>
      <span style={{ fontSize: 12, color: "var(--textMuted)" }}>Recording — tap to stop</span>
    </div>
  );

  if (mode === "uploading") return (
    <div style={{ border: "1.5px dashed var(--border)", borderRadius: 14, padding: "22px 20px", display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
      <div style={{ width: "100%", height: 3, background: "var(--border)", borderRadius: 99 }}>
        <div style={{ height: "100%", width: `${prog}%`, background: "var(--gold)", borderRadius: 99, transition: "width 0.08s" }} />
      </div>
      <span style={{ fontSize: 13, fontWeight: 600, color: "var(--textMuted)" }}>Uploading... {Math.round(prog)}%</span>
    </div>
  );

  return (
    <div style={{ border: "1.5px dashed var(--border)", borderRadius: 14, background: "var(--surface2)", padding: 16 }}>
      <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
        <button type="button" onClick={start} style={{
          flex: 1, height: 58, border: "1.5px solid rgba(239,68,68,0.25)", borderRadius: 12,
          background: "var(--surface)", cursor: "pointer", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", gap: 5, transition: "all 0.2s", fontFamily: "inherit"
        }}
          onMouseEnter={e => { e.currentTarget.style.background = "rgba(239,68,68,0.05)"; e.currentTarget.style.borderColor = "#EF4444"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "var(--surface)"; e.currentTarget.style.borderColor = "rgba(239,68,68,0.25)"; }}
        >
          <div style={{ color: "#EF4444", display: "flex", gap: 5, alignItems: "center" }}>{Icons.recDot}<span style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.5 }}>RECORD</span></div>
        </button>
        <label style={{
          flex: 1, height: 58, border: "1.5px dashed var(--border)", borderRadius: 12,
          background: "var(--surface)", cursor: "pointer", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", gap: 4, transition: "border-color 0.2s"
        }}
          onMouseEnter={e => e.currentTarget.style.borderColor = "var(--gold)"}
          onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}
        >
          <div style={{ color: "var(--textMuted)" }}>{Icons.upload}</div>
          <span style={{ fontSize: 12, fontWeight: 700, color: "var(--textMuted)", letterSpacing: 0.5 }}>UPLOAD</span>
          <input ref={uploadRef} type="file" accept="audio/*" hidden onChange={e => { const f = e.target.files[0]; if (f) uploadFile(f); }} />
        </label>
      </div>
      <p style={{ margin: 0, fontSize: 11, color: "var(--textMuted)", textAlign: "center" }}>Record a voice note or upload an audio file · max 10MB</p>
    </div>
  );
};

// ─── SHIMMER CARD ───
const ShimmerCard = () => (
  <div style={{ background: "var(--surface)", borderRadius: 22, overflow: "hidden", border: "1px solid var(--border)" }}>
    <div style={{ height: 130, background: "var(--surface2)", animation: "shimmer 1.4s infinite" }} />
    <div style={{ padding: "14px 14px 18px" }}>
      <div style={{ height: 14, width: "70%", borderRadius: 7, background: "var(--surface2)", marginBottom: 10, animation: "shimmer 1.4s infinite" }} />
      <div style={{ height: 24, width: "55%", borderRadius: 12, background: "var(--surface2)", animation: "shimmer 1.4s infinite" }} />
    </div>
  </div>
);

// ════════════════════════════════════════════════════
// ─── MAIN COMPONENT ───
// ════════════════════════════════════════════════════
const ManualTerminal = () => {
  const navigate = useNavigate();
  const handleLogout = () => { localStorage.clear(); showToast("success", "Signed out"); setTimeout(() => navigate("/"), 1000); };

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [locations, setLocations] = useState([]);
  const [toast, setToast] = useState(null);
  const [selectedLoc, setSelectedLoc] = useState("");
  const [selectedCat, setSelectedCat] = useState(null);
  const [selectedSub, setSelectedSub] = useState("");
  const [description, setDescription] = useState("");
  const [search, setSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  const [viewMode, setViewMode] = useState("grid");
  const [media, setMedia] = useState({ image: null, video: null, audio: null });
  const [previews, setPreviews] = useState({ image: null });

  const FILTERS = ["All", "A–Z", "Z–A", "Recent"];

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const [catRes, locRes] = await Promise.all([API.get("/categories"), API.get("/admin/locations")]);
        if (catRes.data.success) {
          const rawCats = catRes.data.data || [];
          setCategories(rawCats);
          // Concurrently fetch real HOD & subcategory count for each category using existing endpoints
          Promise.all(
            rawCats.map(async (c) => {
              try {
                const [hodRes, subRes] = await Promise.all([
                  API.get(`/categories/${c.id}/hod`).catch(() => null),
                  API.get(`/categories/${c.id}/subcategories`).catch(() => null)
                ]);
                return {
                  ...c,
                  hod_name: hodRes?.data?.data?.username || hodRes?.data?.data?.email || null,
                  sub_count: subRes?.data?.data?.length || 0
                };
              } catch {
                return c;
              }
            })
          ).then(enriched => {
            setCategories(enriched);
          });
        }
        if (locRes.data.success) setLocations(locRes.data.data);
      } catch { showToast("error", "Connection failed. Please retry."); }
      finally { setLoading(false); }
    })();
  }, []);

  const showToast = (type, msg) => { setToast({ type, msg }); setTimeout(() => setToast(null), 4000); };

  const getFiltered = () => {
    let list = categories.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));
    if (activeFilter === "A–Z") list = [...list].sort((a, b) => a.name.localeCompare(b.name));
    else if (activeFilter === "Z–A") list = [...list].sort((a, b) => b.name.localeCompare(a.name));
    else if (activeFilter === "Recent") list = [...list].reverse();
    return list;
  };
  const filtered = getFiltered();

  const handleCategorySelect = async (cat) => {
    if (!selectedLoc) { showToast("error", "Please select a location first"); return; }
    setLoading(true); setSelectedCat(cat);
    try {
      const res = await API.get(`/admin/sub-categories/${cat.id}`);
      if (res.data.success) { setSubCategories(res.data.data); setStep(2); }
    } catch { showToast("error", "Failed to load issues"); }
    finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedSub) return;
    setLoading(true);
    const fd = new FormData();
    fd.append("category_id", selectedCat.id);
    fd.append("subcategory_id", selectedSub);
    fd.append("description", description);
    fd.append("scanned_location", selectedLoc);
    fd.append("user_id", localStorage.getItem("user_id") || "20");
    if (media.image) fd.append("image", media.image);
    if (media.video) fd.append("video", media.video);
    if (media.audio) fd.append("audio", media.audio);
    try {
      const res = await API.post("/tickets/create", fd, { headers: { "Content-Type": "multipart/form-data" } });
      if (res.data.success) { showToast("success", `Ticket #${res.data.ticket_code} created!`); setTimeout(() => window.location.reload(), 2500); }
    } catch { showToast("error", "Submission failed. Please retry."); }
    finally { setLoading(false); }
  };

  const catEmoji = (name = "") => {
    const map = { it: "💻", hr: "👥", finance: "💰", admin: "🏢", security: "🔒", maintenance: "🔧", electrical: "⚡", housekeeping: "🧹", accounts: "📊", facility: "🏗️" };
    const key = Object.keys(map).find(k => name.toLowerCase().includes(k));
    return key ? map[key] : name.charAt(0).toUpperCase();
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#F8FAFC", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <UserSidebar />

      <div style={{ marginLeft: 280, flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>

        {/* ─── GLOBAL CSS ─── */}
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap');
          *, *::before, *::after { box-sizing: border-box; }
          :root {
            --gold: #D4AF37;
            --goldLight: #ECC84E;
            --goldPale: #FDFBF4;
            --goldBorder: #F5E8BA;
            --bg: #F8FAFC;
            --surface: #FFFFFF;
            --surface2: #F1F5F9;
            --border: #E2E8F0;
            --text1: #1B2559;
            --text2: #475569;
            --textMuted: #A3AED0;
            --success: #10B981;
            --danger: #EF4444;
            --navy: #1B2559;
          }
          body { font-family: 'Plus Jakarta Sans', sans-serif !important; background: #F8FAFC; }
          .cat-card { transition: all 0.22s ease !important; }
          .cat-card:hover { transform: translateY(-4px) !important; box-shadow: 0 14px 30px rgba(27,37,89,0.08) !important; border-color: #D4AF37 !important; }
          .sub-row { transition: all 0.18s ease !important; }
          .sub-row:hover { background: #F8FAFC !important; border-left: 3px solid #1B2559 !important; }
        `}</style>

        {/* ══════ TOP HEADER (Admin/HOD Match) ══════ */}
        <div style={{ padding: "28px 36px 20px", background: "#FFF", borderBottom: "1px solid #F0F2FA", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 11, color: "#A3AED0", fontWeight: 700, letterSpacing: 0.8, marginBottom: 4 }}>EMPLOYEE SERVICE PORTAL</div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 900, color: "#1B2559" }}>Raise New Service Request</h1>
            <p style={{ margin: "3px 0 0", fontSize: 13, color: "#A3AED0", fontWeight: 500 }}>Select a department and lodge your complaint with multimedia proof.</p>
          </div>

          {/* Operational Unit / Location Selector */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#F8FAFC", border: "1.5px solid #E9EDF7", borderRadius: 14, padding: "8px 16px" }}>
            <span style={{ color: "#D4AF37", display: "flex" }}>{Icons.map}</span>
            <select 
              value={selectedLoc} 
              onChange={e => setSelectedLoc(e.target.value)}
              style={{ background: "transparent", border: "none", color: "#1B2559", fontSize: 13, fontWeight: 700, outline: "none", cursor: "pointer", fontFamily: "inherit" }}
            >
              <option value="">Select Operational Unit / Location...</option>
              {locations.map(l => <option key={l.id} value={l.location_name}>{l.location_name}</option>)}
            </select>
          </div>
        </div>

        {/* ══════ STEP WIZARD BAR ══════ */}
        <div style={{ background: "#FFF", borderBottom: "1px solid #F0F2FA", padding: "12px 36px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, maxWidth: 500 }}>
            {[
              { n: 1, label: "Department", icon: Icons.layers },
              { n: 2, label: "Issue Category", icon: Icons.clipboard },
              { n: 3, label: "Description & Proof", icon: Icons.fileText },
            ].map(({ n, label, icon }, i) => {
              const active = step === n, done = step > n;
              return (
                <React.Fragment key={n}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, opacity: active || done ? 1 : 0.4 }}>
                    <div style={{
                      width: 28, height: 28, borderRadius: "50%",
                      background: done ? "#10B981" : active ? "#1B2559" : "#E2E8F0",
                      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                    }}>
                      {done ? <span style={{ color: "#fff" }}>{Icons.check}</span> : <span style={{ color: active ? "#FFF" : "#64748B" }}>{icon}</span>}
                    </div>
                    <span style={{ fontSize: 12, fontWeight: 800, color: active ? "#1B2559" : done ? "#10B981" : "#94A3B8" }}>{label}</span>
                  </div>
                  {i < 2 && <div style={{ flex: 1, height: 2, background: step > n ? "#10B981" : "#E2E8F0" }} />}
                </React.Fragment>
              );
            })}
          </div>
        </div>

      {/* ══════ MAIN ══════ */}
      <main style={{ width: "100%", padding: "32px 36px 100px", boxSizing: "border-box" }}>

        {/* ─── STEP 1: DEPARTMENTS ─── */}
        {step === 1 && (
          <div style={{ animation: "slideUp 0.35s ease" }}>
            {/* Top Toolbar Row */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 16 }}>
              <div>
                <h1 style={{ fontSize: 24, fontWeight: 900, color: "#1B2559", letterSpacing: "-0.5px", margin: "0 0 4px" }}>Select Service Department</h1>
                <p style={{ fontSize: 13, color: "#A3AED0", fontWeight: 500, margin: 0 }}>Choose the relevant department to initiate your support request.</p>
              </div>

              {/* View Switcher & Action Controls */}
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                {/* Search Bar */}
                <div style={{
                  display: "flex", alignItems: "center", gap: 10,
                  background: "#FFF", border: "1.5px solid #E9EDF7",
                  borderRadius: 14, padding: "9px 16px", minWidth: 280,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.03)"
                }}>
                  <span style={{ color: "#D4AF37", display: "flex" }}>{Icons.search}</span>
                  <input
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Search departments or services..."
                    style={{ flex: 1, border: "none", background: "transparent", fontSize: 13, fontFamily: "inherit", color: "#1B2559", fontWeight: 600, outline: "none" }}
                  />
                  {search && (
                    <button type="button" onClick={() => setSearch("")} style={{ background: "none", border: "none", cursor: "pointer", color: "#A3AED0", display: "flex", padding: 0 }}>{Icons.xmark}</button>
                  )}
                </div>

                {/* Grid / List / Table View Buttons */}
                <div style={{ display: "flex", background: "#FFF", padding: 4, borderRadius: 12, border: "1.5px solid #F0F2FA", gap: 4 }}>
                  {[
                    ["grid", Icons.grid, "Grid View"],
                    ["list", Icons.list, "List View"],
                    ["table", Icons.clipboard, "Table View"]
                  ].map(([v, ic, lbl]) => (
                    <button
                      key={v}
                      type="button"
                      title={lbl}
                      onClick={() => setViewMode(v)}
                      style={{
                        padding: "7px 14px", borderRadius: 9,
                        background: viewMode === v ? "#FFFDF5" : "transparent",
                        color: viewMode === v ? "#D4AF37" : "#A3AED0",
                        border: viewMode === v ? "1.5px solid #F5E8BA" : "1.5px solid transparent",
                        cursor: "pointer", display: "flex", alignItems: "center", gap: 6,
                        fontSize: 12, fontWeight: 700, fontFamily: "inherit",
                        transition: "all 0.18s ease"
                      }}
                    >
                      {ic}
                      <span style={{ display: "inline-block" }}>{v.charAt(0).toUpperCase() + v.slice(1)}</span>
                    </button>
                  ))}
                </div>

                <div style={{ padding: "8px 16px", background: "#FFFDF5", borderRadius: 12, border: "1.5px solid #F5E8BA" }}>
                  <span style={{ fontSize: 13, fontWeight: 800, color: "#D4AF37" }}>{filtered.length} Departments</span>
                </div>
              </div>
            </div>

            {/* Quick Filter Chips */}
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 24, overflowX: "auto", paddingBottom: 4 }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: "#A3AED0", marginRight: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>Sort & Filter:</span>
              {FILTERS.map(f => (
                <button
                  key={f}
                  type="button"
                  onClick={() => setActiveFilter(f)}
                  style={{
                    padding: "6px 16px", borderRadius: 20,
                    border: `1.5px solid ${activeFilter === f ? "#F5E8BA" : "#F0F2FA"}`,
                    background: activeFilter === f ? "#FFFDF5" : "#FFF",
                    color: activeFilter === f ? "#D4AF37" : "#64748B",
                    fontSize: 12, fontWeight: 700, fontFamily: "inherit", cursor: "pointer",
                    transition: "all 0.18s ease",
                    boxShadow: activeFilter === f ? "0 2px 8px rgba(212,175,55,0.15)" : "none"
                  }}
                >
                  {f}
                </button>
              ))}
            </div>

            {/* ─── RENDERING MODES (GRID / LIST / TABLE) ─── */}
            {loading ? (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 20 }}>
                {[...Array(6)].map((_, i) => <ShimmerCard key={i} />)}
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ background: "#FFF", borderRadius: 20, border: "1.5px solid #E9EDF7", padding: "80px 20px", textAlign: "center" }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#FFFDF5", border: "1.5px solid #F5E8BA", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", color: "#D4AF37" }}>
                  {Icons.search}
                </div>
                <h3 style={{ margin: "0 0 6px", fontSize: 18, fontWeight: 800, color: "#1B2559" }}>No departments found</h3>
                <p style={{ margin: 0, fontSize: 13, color: "#A3AED0" }}>No matching category found for "{search}". Please try clearing filters.</p>
              </div>
            ) : viewMode === "grid" ? (
              /* ── 1. EXACT ADMIN GRID VIEW (Admin Categories Hub Style) ── */
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(310px, 1fr))", gap: 20 }}>
                {filtered.map((cat, i) => (
                  <div
                    key={cat.id}
                    className="cat-card"
                    onClick={() => handleCategorySelect(cat)}
                    style={{
                      background: "#FFFFFF", borderRadius: 22, cursor: "pointer",
                      border: "1.5px solid #F0F2FA", boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                      padding: 22, display: "flex", flexDirection: "column",
                      justifyContent: "space-between", animation: `slideUp 0.3s ease ${i * 0.04}s both`,
                      position: "relative"
                    }}
                  >
                    <div>
                      {/* Top Row: Icon + Sub count */}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
                        <div style={{
                          width: 52, height: 52, borderRadius: 16, background: "#FFFDF5",
                          border: "1.5px solid #F5E8BA", display: "flex", alignItems: "center",
                          justifyContent: "center", overflow: "hidden"
                        }}>
                          {cat.image ? (
                            <img src={`https://api.ajplservices.tech/${cat.image}`} alt={cat.name} style={{ width: 36, height: 36, objectFit: "contain" }} onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
                          ) : null}
                          <div style={{ display: cat.image ? "none" : "flex", color: "#D4AF37", alignItems: "center", justifyContent: "center" }}>
                            {Icons.layers}
                          </div>
                        </div>
                        <div style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "5px 12px", background: "#FFFDF5", border: "1px solid #F5E8BA", borderRadius: 10, fontSize: 11, fontWeight: 800, color: "#D4AF37" }}>
                          {Icons.layers} {cat.sub_count || 0} Sub-Categories
                        </div>
                      </div>

                      {/* Title & Desc */}
                      <h3 style={{ margin: "0 0 8px", fontSize: 17, fontWeight: 800, color: "#1B2559" }}>{cat.name}</h3>
                      <p style={{ fontSize: 12.5, color: "#64748B", lineHeight: 1.6, marginBottom: 18, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                        {cat.description || "General maintenance and operational support for this department."}
                      </p>
                    </div>

                    {/* Footer Row matching Admin Category Card */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 14, borderTop: "1.5px solid #F8FAFC" }}>
                      <div style={{ fontSize: 12, color: "#1B2559", fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                        <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#D4AF37" }} />
                        <span style={{ color: "#A3AED0", fontWeight: 600 }}>HOD:</span>
                        <span>{cat.hod_name || "Unassigned"}</span>
                      </div>
                      <div style={{
                        display: "inline-flex", alignItems: "center", gap: 5,
                        padding: "6px 14px", background: "#FFFDF5", color: "#D4AF37",
                        border: "1px solid #F5E8BA", borderRadius: 10, fontSize: 11, fontWeight: 800,
                        cursor: "pointer", transition: "all 0.15s ease"
                      }}>
                        Select {Icons.chevron}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : viewMode === "list" ? (
              /* ── 2. EXACT ADMIN LIST VIEW ── */
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {filtered.map((cat, i) => (
                  <div
                    key={cat.id}
                    className="cat-card"
                    onClick={() => handleCategorySelect(cat)}
                    style={{
                      background: "#FFFFFF", borderRadius: 16, cursor: "pointer",
                      border: "1.5px solid #F0F2FA", padding: "16px 24px",
                      display: "flex", alignItems: "center", justifyContent: "space-between",
                      gap: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
                      animation: `slideUp 0.25s ease ${i * 0.03}s both`
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 18, flex: 1, minWidth: 0 }}>
                      <div style={{
                        width: 48, height: 48, borderRadius: 14, background: "#FFFDF5",
                        border: "1.5px solid #F5E8BA", display: "flex", alignItems: "center",
                        justifyContent: "center", flexShrink: 0, overflow: "hidden"
                      }}>
                        {cat.image ? (
                          <img src={`https://api.ajplservices.tech/${cat.image}`} alt={cat.name} style={{ width: 32, height: 32, objectFit: "contain" }} onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
                        ) : null}
                        <div style={{ display: cat.image ? "none" : "flex", color: "#D4AF37", alignItems: "center", justifyContent: "center" }}>
                          {Icons.layers}
                        </div>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <h4 style={{ margin: "0 0 2px", fontSize: 16, fontWeight: 800, color: "#1B2559" }}>{cat.name}</h4>
                          <span style={{ padding: "2px 8px", background: "#F1F5F9", borderRadius: 6, fontSize: 10, fontWeight: 700, color: "#64748B" }}>
                            {cat.sub_count || 0} Issues
                          </span>
                        </div>
                        <p style={{ margin: 0, fontSize: 12.5, color: "#64748B", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {cat.description || "General maintenance and operational support for this department."}
                        </p>
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 24, flexShrink: 0 }}>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: "#A3AED0", textTransform: "uppercase", letterSpacing: 0.5 }}>Concern Person (HOD)</div>
                        <div style={{ fontSize: 13, fontWeight: 800, color: "#1B2559", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 5 }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#D4AF37" }} />
                          {cat.hod_name || "Unassigned"}
                        </div>
                      </div>
                      <div style={{ padding: "7px 16px", background: "#FFFDF5", color: "#D4AF37", border: "1.5px solid #F5E8BA", borderRadius: 10, fontSize: 11, fontWeight: 800, letterSpacing: 0.3, display: "flex", alignItems: "center", gap: 4 }}>
                        Select {Icons.chevron}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              /* ── 3. EXACT ADMIN TABLE VIEW ── */
              <div style={{ background: "#FFFFFF", borderRadius: 18, border: "1px solid #F0F2FA", overflowX: "auto", boxShadow: "0 4px 20px rgba(0,0,0,0.03)" }}>
                <table style={{ width: "100%", minWidth: 780, borderCollapse: "collapse", textAlign: "left" }}>
                  <thead>
                    <tr style={{ background: "#F8FAFC", borderBottom: "1.5px solid #F0F2FA" }}>
                      <th style={{ padding: "14px 18px", fontSize: 10.5, fontWeight: 800, color: "#A3AED0", textTransform: "uppercase", letterSpacing: 0.5, width: "26%" }}>Department / Service</th>
                      <th style={{ padding: "14px 16px", fontSize: 10.5, fontWeight: 800, color: "#A3AED0", textTransform: "uppercase", letterSpacing: 0.5 }}>Description</th>
                      <th style={{ padding: "14px 16px", fontSize: 10.5, fontWeight: 800, color: "#A3AED0", textTransform: "uppercase", letterSpacing: 0.5, width: "20%" }}>Concern Person (HOD)</th>
                      <th style={{ padding: "14px 16px", fontSize: 10.5, fontWeight: 800, color: "#A3AED0", textTransform: "uppercase", letterSpacing: 0.5, width: "15%" }}>Sub-Protocols</th>
                      <th style={{ padding: "14px 18px", fontSize: 10.5, fontWeight: 800, color: "#A3AED0", textTransform: "uppercase", letterSpacing: 0.5, textAlign: "right", width: "12%" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((cat, i) => (
                      <tr
                        key={cat.id}
                        className="cat-card"
                        onClick={() => handleCategorySelect(cat)}
                        style={{
                          borderBottom: i < filtered.length - 1 ? "1px solid #F8FAFC" : "none",
                          cursor: "pointer", transition: "background 0.15s ease"
                        }}
                      >
                        <td style={{ padding: "13px 18px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{
                              width: 38, height: 38, borderRadius: 10, background: "#FFFDF5",
                              border: "1.5px solid #F5E8BA", display: "flex", alignItems: "center",
                              justifyContent: "center", flexShrink: 0, overflow: "hidden"
                            }}>
                              {cat.image ? (
                                <img src={`https://api.ajplservices.tech/${cat.image}`} alt={cat.name} style={{ width: 24, height: 24, objectFit: "contain" }} onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
                              ) : null}
                              <div style={{ display: cat.image ? "none" : "flex", color: "#D4AF37", alignItems: "center", justifyContent: "center" }}>
                                {Icons.layers}
                              </div>
                            </div>
                            <div>
                              <span style={{ fontSize: 13.5, fontWeight: 800, color: "#1B2559", display: "block" }}>{cat.name}</span>
                              <span style={{ fontSize: 10.5, fontWeight: 600, color: "#A3AED0" }}>ID #{cat.id}</span>
                            </div>
                          </div>
                        </td>
                        <td style={{ padding: "13px 16px", fontSize: 12, color: "#64748B", maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {cat.description || "Operational maintenance & support."}
                        </td>
                        <td style={{ padding: "13px 16px" }}>
                          <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "4px 10px", background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: 8, fontSize: 11, fontWeight: 700, color: "#1B2559" }}>
                            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#D4AF37" }} />
                            {cat.hod_name || "Unassigned"}
                          </span>
                        </td>
                        <td style={{ padding: "13px 16px" }}>
                          <span style={{ padding: "3px 8px", background: "#FFFDF5", border: "1px solid #F5E8BA", borderRadius: 6, fontSize: 10.5, fontWeight: 800, color: "#D4AF37" }}>
                            {cat.sub_count ? `${cat.sub_count} Subcategories` : "0 Protocols"}
                          </span>
                        </td>
                        <td style={{ padding: "13px 18px", textAlign: "right" }}>
                          <button
                            type="button"
                            style={{
                              padding: "5px 12px", background: "#FFFDF5", color: "#D4AF37",
                              border: "1.5px solid #F5E8BA", borderRadius: 8, fontSize: 11, fontWeight: 800,
                              cursor: "pointer", letterSpacing: 0.2, transition: "all 0.15s ease",
                              display: "inline-flex", alignItems: "center", gap: 4, whiteSpace: "nowrap"
                            }}
                            onMouseEnter={e => { e.currentTarget.style.background = "#D4AF37"; e.currentTarget.style.color = "#FFF"; }}
                            onMouseLeave={e => { e.currentTarget.style.background = "#FFFDF5"; e.currentTarget.style.color = "#D4AF37"; }}
                          >
                            Select {Icons.chevron}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* ─── STEP 2: ISSUE TYPE (untouched as requested) ─── */}
        {step === 2 && (
          <div style={{ animation: "slideUp 0.4s ease" }}>
            <button type="button" onClick={() => setStep(1)} style={{ display: "flex", alignItems: "center", gap: 8, background: "none", border: "none", color: "var(--textMuted)", fontWeight: 600, fontSize: 13, cursor: "pointer", marginBottom: 26, fontFamily: "inherit", transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "var(--text1)"}
              onMouseLeave={e => e.currentTarget.style.color = "var(--textMuted)"}
            >{Icons.back} &nbsp;Back to Departments</button>

            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 26, paddingBottom: 22, borderBottom: "1px solid var(--border)" }}>
              <div style={{ width: 50, height: 50, borderRadius: 14, background: "var(--goldPale)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, border: "1px solid var(--goldBorder)", flexShrink: 0 }}>
                {catEmoji(selectedCat?.name)}
              </div>
              <div>
                <h2 style={{ fontSize: 21, fontWeight: 700, color: "var(--text1)", marginBottom: 2, letterSpacing: "-0.3px" }}>{selectedCat?.name}</h2>
                <p style={{ fontSize: 13, color: "var(--textMuted)" }}>Select the specific issue</p>
              </div>
            </div>

            <div style={{ background: "var(--surface)", borderRadius: 18, border: "1px solid rgba(0,0,0,0.07)", overflow: "hidden", boxShadow: "0 4px 18px rgba(0,0,0,0.05)" }}>
              {subCategories.map((sub, i) => (
                <div key={sub.id} className="sub-row" onClick={() => { setSelectedSub(sub.id); setStep(3); }}
                  style={{ padding: "18px 22px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer", borderBottom: i < subCategories.length - 1 ? "1px solid var(--border)" : "none", borderLeft: "3px solid transparent", background: "var(--surface)", animation: `fadeIn 0.3s ease ${i * 0.05}s both` }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--gold)", flexShrink: 0 }} />
                  <span style={{ flex: 1, fontSize: 14.5, fontWeight: 500, color: "var(--text1)" }}>{sub.name}</span>
                  <span style={{ color: "var(--gold)" }}>{Icons.chevron}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ─── STEP 3: DETAILS ─── */}
        {step === 3 && (
          <form onSubmit={handleSubmit} style={{ animation: "slideUp 0.4s ease" }}>
            <button type="button" onClick={() => setStep(2)} style={{ display: "flex", alignItems: "center", gap: 8, background: "none", border: "none", color: "var(--textMuted)", fontWeight: 600, fontSize: 13, cursor: "pointer", marginBottom: 26, fontFamily: "inherit", transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "var(--text1)"}
              onMouseLeave={e => e.currentTarget.style.color = "var(--textMuted)"}
            >{Icons.back} &nbsp;Back to Issues</button>

            {/* Context strip */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 18px", background: "var(--surface)", borderRadius: 14, border: "1px solid var(--border)", marginBottom: 24, boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize: 22 }}>{catEmoji(selectedCat?.name)}</div>
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontSize: 11, color: "var(--textMuted)", fontWeight: 500 }}>Raising ticket for</p>
                <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: "var(--text1)" }}>{selectedCat?.name}</p>
              </div>
              <div style={{ padding: "5px 13px", background: "var(--goldPale)", borderRadius: 20, fontSize: 12, fontWeight: 600, color: "var(--gold)", border: "1px solid var(--goldBorder)" }}>{selectedLoc}</div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              {/* Description */}
              <div style={{ background: "var(--surface)", borderRadius: 18, padding: 22, border: "1px solid rgba(0,0,0,0.07)", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 11, fontWeight: 700, color: "var(--textMuted)", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 12 }}>
                  {Icons.fileText} Description <span style={{ color: "var(--danger)" }}>*</span>
                </label>
                <textarea required value={description} onChange={e => setDescription(e.target.value)}
                  placeholder="Describe the issue clearly — what happened, when it started, which area..."
                  style={{ width: "100%", height: 126, padding: "14px 15px", borderRadius: 12, border: "1.5px solid var(--border)", fontSize: 14, fontFamily: "'Poppins', sans-serif", color: "var(--text1)", resize: "vertical", background: "var(--surface2)", lineHeight: 1.7, transition: "all 0.2s" }}
                />
              </div>

              {/* Media */}
              <div style={{ background: "var(--surface)", borderRadius: 18, padding: 22, border: "1px solid rgba(0,0,0,0.07)", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                <p style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 11, fontWeight: 700, color: "var(--textMuted)", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 18 }}>
                  {Icons.upload} &nbsp;Attach Evidence
                  <span style={{ fontSize: 11, fontWeight: 400, textTransform: "none", letterSpacing: 0, color: "var(--textMuted)", marginLeft: 4 }}>(optional · max 10MB each)</span>
                </p>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                  <div>
                    <p style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, color: "var(--text2)", marginBottom: 8 }}>{Icons.camera} Photo</p>
                    <DropZone type="image" accept="image/*" icon={Icons.camera} label="Image" file={media.image} preview={previews.image}
                      onFile={f => { setMedia(p => ({ ...p, image: f })); const r = new FileReader(); r.onloadend = () => setPreviews(p => ({ ...p, image: r.result })); r.readAsDataURL(f); }}
                      onRemove={() => { setMedia(p => ({ ...p, image: null })); setPreviews({ image: null }); }}
                    />
                  </div>
                  <div>
                    <p style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, color: "var(--text2)", marginBottom: 8 }}>{Icons.video} Video</p>
                    <DropZone type="video" accept="video/*" icon={Icons.video} label="Video" file={media.video} preview={null}
                      onFile={f => setMedia(p => ({ ...p, video: f }))}
                      onRemove={() => setMedia(p => ({ ...p, video: null }))}
                    />
                  </div>
                </div>
                <div>
                  <p style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, color: "var(--text2)", marginBottom: 8 }}>{Icons.mic} Voice Note / Audio</p>
                  <AudioRecorder audioFile={media.audio} onAudio={f => setMedia(p => ({ ...p, audio: f }))} onRemove={() => setMedia(p => ({ ...p, audio: null }))} />
                </div>
              </div>

              {/* Submit */}
              <button type="submit" disabled={loading} style={{
                width: "100%", padding: "17px", borderRadius: 15, border: "none",
                background: loading ? "var(--border)" : "var(--gold)",
                color: loading ? "var(--textMuted)" : "var(--navy)", fontWeight: 800, fontSize: 15,
                cursor: loading ? "not-allowed" : "pointer", fontFamily: "'Poppins', sans-serif",
                display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                letterSpacing: "0.5px", boxShadow: loading ? "none" : "0 8px 28px rgba(212,175,55,0.35)", transition: "all 0.2s"
              }}
                onMouseEnter={e => { if (!loading) { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 12px 36px rgba(212,175,55,0.45)"; }}}
                onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = loading ? "none" : "0 8px 28px rgba(212,175,55,0.35)"; }}
              >
                {loading
                  ? <><div style={{ width: 18, height: 18, border: "2.5px solid rgba(0,0,0,0.2)", borderTopColor: "var(--text1)", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} /> Submitting...</>
                  : <>{Icons.send} Raise Support Ticket</>
                }
              </button>
            </div>
          </form>
        )}
      </main>

      {/* ══════ TOAST ══════ */}
      {toast && (
        <div style={{
          position: "fixed", bottom: 30, left: "50%", transform: "translateX(-50%)",
          padding: "13px 26px", borderRadius: 50,
          background: toast.type === "success" ? "var(--navy)" : "#DC2626",
          color: toast.type === "success" ? "var(--gold)" : "#fff",
          border: toast.type === "success" ? "1px solid rgba(212,175,55,0.25)" : "none",
          boxShadow: "0 12px 40px rgba(0,0,0,0.2)", display: "flex", alignItems: "center",
          gap: 10, zIndex: 9999, fontWeight: 700, fontSize: 14, whiteSpace: "nowrap",
          animation: "toastUp 0.3s cubic-bezier(0.16,1,0.3,1)", fontFamily: "'Poppins', sans-serif"
        }}>
          {toast.type === "success" ? Icons.checkCircle : Icons.alertCircle} {toast.msg}
        </div>
      )}

      {/* ══════ FOOTER ══════ */}
      <footer style={{ textAlign: "center", padding: "26px", color: "var(--textMuted)", fontSize: 12, fontWeight: 500, borderTop: "1px solid var(--border)" }}>
        © 2026 Achal Jewels &nbsp;·&nbsp; Internal Support Hub
      </footer>
      </div>
    </div>
  );
};

export default ManualTerminal;